import React from "react";
import { Dropdown } from "react-bootstrap";

const CategoryMenu = ({ category, editCategory, toggleCategoryActivity, userIsSuperAdmin }) => {
  return (
    <Dropdown align="end" onClick={(e) => e.stopPropagation()}>
      <Dropdown.Toggle variant="link" id={`category-menu-${category?.id}`} data-testid="toggle-btn">
        {/* small ellipsis or icon can be styled here */}
        <span style={{ fontSize: 18, lineHeight: 1.2 }}>⋮</span>
      </Dropdown.Toggle>

      <Dropdown.Menu>
        <Dropdown.Item onClick={() => editCategory && editCategory(category)}>
          Edit
        </Dropdown.Item>
        <Dropdown.Item onClick={() => toggleCategoryActivity && toggleCategoryActivity(category)}>
          {category?.isActive ? "Archive" : "Activate"}
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default CategoryMenu;
